// extracted by mini-css-extract-plugin
export default {"page-head":"PageHead_page-head__7Jq5O"};